import { useEffect, useRef } from 'react';

// Web client ID (OAuth) — đặt trong portal/web/.env: REACT_APP_GOOGLE_CLIENT_ID=xxx.apps.googleusercontent.com
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';
const GSI_SRC = 'https://accounts.google.com/gsi/client';

/** Nạp script Google Identity Services đúng 1 lần. */
function loadGsi() {
  return new Promise((resolve, reject) => {
    if (window.google?.accounts?.id) return resolve();
    let s = document.querySelector(`script[src="${GSI_SRC}"]`);
    if (s) { s.addEventListener('load', () => resolve()); s.addEventListener('error', reject); return; }
    s = document.createElement('script');
    s.src = GSI_SRC; s.async = true; s.defer = true;
    s.onload = () => resolve(); s.onerror = reject;
    document.head.appendChild(s);
  });
}

/**
 * Nút "Đăng nhập bằng Google" (GIS). Khi có id_token -> gọi onCredential(idToken).
 * Nếu chưa cấu hình REACT_APP_GOOGLE_CLIENT_ID thì không hiện gì.
 */
export default function GoogleButton({ onCredential, onError }) {
  const boxRef = useRef(null);

  useEffect(() => {
    if (!CLIENT_ID || !boxRef.current) return;
    let cancelled = false;
    loadGsi()
      .then(() => {
        if (cancelled || !window.google?.accounts?.id) return;
        window.google.accounts.id.initialize({
          client_id: CLIENT_ID,
          callback: (resp) => {
            if (resp?.credential) onCredential?.(resp.credential);
            else onError?.(new Error('Không lấy được thông tin Google'));
          },
        });
        window.google.accounts.id.renderButton(boxRef.current, {
          theme: 'outline', size: 'large', width: 360, text: 'signin_with', shape: 'pill',
        });
      })
      .catch(() => onError?.(new Error('Không tải được Google Sign-In')));
    return () => { cancelled = true; };
  }, [onCredential, onError]);

  if (!CLIENT_ID) return null;
  return <div ref={boxRef} style={{ display: 'flex', justifyContent: 'center', width: '100%' }} />;
}
